import { useState } from "react";
import { Grid } from "@material-ui/core"
import { dayMonthDateFormat, fieldDMYShort } from '../../constants'
import moment from 'moment'
import { acumenCamo } from "../../shared_elements/components";
import { Comma_format } from "../../utils";

const sCell = { padding: '6px 8px', };
const sLabel = { display: 'block', fontSize: '14px', fontWeight: 700, marginBottom: '2px', lineHeight: '1.4', fontFamily: "Roboto,Helvetica,Arial,sans-serif" };
const sValue = { display: 'block', fontSize: '14px', wordBreak: 'break-word', fontFamily: "Roboto,Helvetica,Arial,sans-serif" };

function EngOnOffWingList({ basicDetailData}) {
	const [lessMore, setLessMore] = useState({});
	const toggleLessMore = (lessMr) => {
		setLessMore({ ...lessMore, [lessMr]: !lessMore[lessMr] });
	}
	const lessMoreFn = (name, lessMr) => {
		return <>
			{name && name?.length > 50 ? (
				<>
					{lessMore[lessMr] ?
						(<> {name} <span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}> ..less </span> </>)
						:
						(<>{name.substring(0, 50)} <span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}> ..more </span> </>)
					}
				</>
			) : name || '--'
			}
		</>
	}
	
	return (
		<Grid container spacing={0}>
			<Grid item xs={6} sm={4} md={2}>
				<div style={sCell}>
					<span style={sLabel}>Wing Status</span>
					<span style={sValue}>{
						(basicDetailData?.on_wing_status === undefined ||
							basicDetailData?.on_wing_status === null)
							? "--"
							: basicDetailData?.on_wing_status
								? "On Wing"
								: "Off Wing"}</span>
				</div>
			</Grid>
			{basicDetailData?.on_wing_status && (
				<Grid item xs={6} sm={4} md={2}>
					<div style={sCell}>
						<span style={sLabel}>On Wing MSN</span>
						<span style={sValue}>{basicDetailData?.on_wing_msn || '--'}</span>
					</div>
				</Grid>
			)}
			{basicDetailData?.on_wing_status && (
				<Grid item xs={6} sm={4} md={2}>
					<div style={sCell}>
						<span style={sLabel}>On Wing Owner</span>
						<span style={sValue}>{basicDetailData?.on_wing_lessor || '--'}</span>
					</div>
				</Grid>
			)}
			{basicDetailData?.off_wing_status && (
				<Grid item xs={6} sm={4} md={2}>
					<div style={sCell}>
						<span style={sLabel}>Off wing Condition</span>
						<span style={sValue}>{basicDetailData?.off_wing_status?.label || '--'}</span>
					</div>
				</Grid>
			)}
			{basicDetailData?.off_wing_detail && (
				<>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>TSN of Engine Removal</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.tsn_at_removal ? Comma_format((Number(basicDetailData?.off_wing_detail?.tsn_at_removal)).toFixed(2)) : '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>CSN of Engine Removal</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.csn_at_removal ? Comma_format(parseInt(basicDetailData?.off_wing_detail?.csn_at_removal)) : '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Date of Engine Removal</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.date_of_removal ? moment(basicDetailData?.off_wing_detail?.date_of_removal).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Reason of Engine Removal</span>
							<span style={sValue}>{lessMoreFn(basicDetailData?.off_wing_detail?.removal_reason ? basicDetailData?.off_wing_detail?.removal_reason : basicDetailData?.off_wing_detail?.reason_for_removal, 'reason_for_removal')}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Preservation Performed</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.preservation_performed ? "YES" : "NO" || '--'}</span>
						</div>
					</Grid>
				</>
			)}

			{basicDetailData?.off_wing_status?.value === 2 && (
				<>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Release Date of the Assembly</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.release_date_of_the_engine ? moment(basicDetailData?.off_wing_detail?.release_date_of_the_engine).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Shop Visit Report Provided</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.shop_visit_report_provided ? "YES" : "NO" || '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Type of Shop Visit</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.type_of_shop_visit?.label || '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Expected Date of Shipment Back to Lessee</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.expected_date_of_shipment_back_to_lessee ? moment(basicDetailData?.off_wing_detail?.expected_date_of_shipment_back_to_lessee).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Facility Name</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.shop_visit_name || '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Facility Location</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.shop_visit_location || '--'}</span>
						</div>
					</Grid>
				</>
			)}

			{basicDetailData?.off_wing_status?.value === 3 && (
				<>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Expected Release Date of the Assembly?</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.expected_release_date_of_the_engine ? moment(basicDetailData?.off_wing_detail?.expected_release_date_of_the_engine).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Induction Date of Assembly</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.induction_date_of_engine ? moment(basicDetailData?.off_wing_detail?.induction_date_of_engine).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Workscope Status</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.work_scope_status?.label || '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Facility Name</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.shop_visit_name || '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Facility Location</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.shop_visit_location || '--'}</span>
						</div>
					</Grid>
				</>
			)}

			{basicDetailData?.off_wing_status?.value === 4 && (
				<>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Expected Date of Installation On Aircraft</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.expected_date_of_installation_on_wing ? moment(basicDetailData?.off_wing_detail?.expected_date_of_installation_on_wing).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Shop Visit Performed</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.shop_visit_performed ? "YES" : "NO" || '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Shop Visit Report Status</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.shop_visit_report_status?.label || '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Asset Location</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.off_wing_location || '--'}</span>
						</div>
					</Grid>
				</>
			)}

			{basicDetailData?.off_wing_status?.value === 5 && (
				<>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Shop Visit Requirement</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.shop_visit_requirement?.label || '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Expected Date of Shipment Shop</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.expected_date_of_shipment_to_shop ? moment(basicDetailData?.off_wing_detail?.expected_date_of_shipment_to_shop).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Which Shop has Been Selected ?</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.selected_shop || '--'}</span>
						</div>
					</Grid>
					<Grid item xs={6} sm={4} md={2}>
						<div style={sCell}>
							<span style={sLabel}>Asset Location</span>
							<span style={sValue}>{basicDetailData?.off_wing_detail?.off_wing_location || '--'}</span>
						</div>
					</Grid>
				</>
			)}
		</Grid>
	)
}

export default EngOnOffWingList
